import React from 'react';
import { useTranslation } from 'react-i18next';
import { GraduationCap, BookOpen, Award } from 'lucide-react';
import './Timeline.css';

// Wording (degree, highlights) lives in i18n under `education.data.<key>`.
const education = [
    { key: 'engineering', school: 'ISSATSo, Sousse', duration: '2023 – 2026', Icon: GraduationCap },
    { key: 'prepa', school: 'ISSATSo, Sousse', duration: '2021 – 2023', Icon: BookOpen },
    { key: 'bac', schoolKey: 'education.high_school', duration: '2021', Icon: Award },
];

const EducationSection = () => {
    const { t } = useTranslation();

    return (
        <div className="timeline-column" id="Education">
            <div className="section-header">
                <span className="eyebrow">{t('education.eyebrow')}</span>
                <h2 className="section-title timeline-heading">{t('education.title')}</h2>
            </div>

            <ol className="timeline timeline--spaced">
                {education.map(({ key, school, schoolKey, duration, Icon }) => {
                    const data = `education.data.${key}`;
                    return (
                        <li key={key} className="timeline-item reveal">
                            <span className="timeline-logo timeline-logo--icon">
                                <Icon size={24} />
                            </span>
                            <div className="timeline-content">
                                <div className="timeline-row">
                                    <h3 className="timeline-title">{t(`${data}.degree`)}</h3>
                                    <span className="timeline-date">{duration}</span>
                                </div>
                                <p className="timeline-org">{school || t(schoolKey)}</p>
                                <ul className="timeline-bullets">
                                    {t(`${data}.highlights`, { returnObjects: true }).map(h => <li key={h}>{h}</li>)}
                                </ul>
                            </div>
                        </li>
                    );
                })}
            </ol>
        </div>
    );
};

export default EducationSection;
